import { axiosInstance } from "@/api/apiClient";
import {
  ConversationsApi,
  ConversationsApiMessagingViewsConversationListConversationItemAsGuestRequest,
  ConversationsApiMessagingViewsConversationListConversationItemRequest,
  ConversationsApiMessagingViewsConversationListConversationNoteRequest,
  ConversationsApiMessagingViewsConversationListConversationsRequest,
} from "@/api/client";
import { CustomAxiosRequestConfig } from "@/api/types";
import { BASE_API } from "@/helpers/constants";

const api = new ConversationsApi(undefined, BASE_API, axiosInstance);

export const getConversations = async (
  payload: ConversationsApiMessagingViewsConversationListConversationsRequest
) => {
  return api.messagingViewsConversationListConversations.bind(api)(payload);
};

export const getConversationNotes = async (
  payload: ConversationsApiMessagingViewsConversationListConversationNoteRequest
) => {
  return api.messagingViewsConversationListConversationNote.bind(api)(payload);
};

export const getConversationItems = async (
  payload: ConversationsApiMessagingViewsConversationListConversationItemRequest
) => {
  return api.messagingViewsConversationListConversationItem.bind(api)(payload);
};

export const getConversationItemsAsGuest = async (
  payload: ConversationsApiMessagingViewsConversationListConversationItemAsGuestRequest,
  options?: CustomAxiosRequestConfig
) => {
  return api.messagingViewsConversationListConversationItemAsGuest.bind(api)(
    payload,
    options
  );
};
